import type { ReactNode } from 'react'

export function Panel({
  title,
  children,
  className = '',
  raised = false,
  actions,
}: {
  title?: string
  children: ReactNode
  className?: string
  raised?: boolean
  actions?: ReactNode
}) {
  return (
    <section className={`${raised ? 'panel-raised' : 'panel'} ${className}`}>
      {title ? (
        <header className="flex items-center justify-between border-b border-lime-soft px-4 py-2">
          <h2 className="text-xs uppercase tracking-widest text-crt-lime">
            {title}
          </h2>
          {actions}
        </header>
      ) : null}
      <div className="p-4">{children}</div>
    </section>
  )
}
